import axios from "axios";
import { useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import BackBtn from "../../../components/Common/backBtn";
import InputTextField from "../../../components/Common/inputTextField";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import SucessModal from "../../../components/Modal/SucessModal";
import { uploadToSpaces } from "../../Masters/Utils/uploadToSpaces";

const AddStoreLocationForm = ({ edit = false, view = false }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const {
    register,
    setValue,
    watch,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  console.log("setvalu", setValue);
  const [success, setSuccess] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [checked, setChecked] = useState(true);

  const getStoreData = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}healthsy-pharmacy/store-location/get/${id}`
      )
      .then((res) => {
        const data = res.data;
        setValue("town", data.town);
        setValue("city", data.city);
        setValue("tag", data.tag?.states);
        setValue("storeCount", data.tag?.number_of_pharmacies);
        setValue("status", setChecked(data.active));

        if (data.photos?.length) {
          setImageFile(data.photos[0]);
        }
      })
      .catch((err) => {
        console.error(err);
        alert("Error fetching store location data");
      });
  };

  useEffect(() => {
    if (edit || view) getStoreData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit, view]);

  console.log("gertval", getValues("status"));
  const onSubmit = async (fields) => {
    console.log("fields: ", fields);
    try {
      let imageUrl = "";

      if (imageFile && typeof imageFile !== "string") {
        imageUrl = await uploadToSpaces(
          imageFile,
          "HealthSyRetailPharmacy/franchiseStore/StoreLocations/"
        );
      } else if (typeof imageFile === "string") {
        imageUrl = imageFile;
      }

      const payload = {
        town: fields.town,
        city: fields.city,
        tag: {
          number_of_pharmacies:
            fields.tag === "Open Now" ? fields.storeCount : "",
          states: fields.tag,
        },
        active: fields.active,
        photos: imageUrl ? [imageUrl] : [],
      };
      if (edit) {
        const res = await axios.patch(
          `${process.env.REACT_APP_API_URL}healthsy-pharmacy/store-location/update/${id}`,
          payload
        );
        console.log("res", res);
        if (res?.statusText) setSuccess(true);
        else alert("Update failed");
      } else {
        console.log("payload: ", payload);

        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}healthsy-pharmacy/store-location/create`,
          payload
        );
        if (res?.statusText) setSuccess(true);
        else alert("Create failed");
      }
    } catch (err) {
      console.error("Submit failed: ", err);
      alert("Something went wrong");
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Franchise programme", link: " " },
      { text: "Store Locations", link: "/franchise-programme/store-locations" },
      {
        text: edit
          ? "Edit Store Location"
          : view
            ? "View Store Location"
            : "Add New Store Location",
        link: "",
      },
    ],
    [edit, view]
  );

  return (
    <>
      <MainconternLayout
        header={
          <>
            <div className="d-flex flex-column pb-2 flex-wrap justify-content-start gap-4">
              <Breadcrumbs
                className="w-75 healthsyMasterBreadCrumbs"
                breadcrumbsList={breadcrumbsList}
              />
              <BackBtn navigatePath="/franchise-programme/store-locations" />
            </div>
          </>
        }
        footer={<></>}
      >
        <div className="healtharticle">
          <form onSubmit={handleSubmit(onSubmit)} className="carr-dep-form">
            <div className="row car-dep-form g-4 m-3">
              {/* Left Column */}
              <div className="col-md-6 d-flex flex-column gap-4">
                {/* Location */}
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="Town"
                  errorText="Please enter the location"
                  name="town"
                  placeholder="Enter Location"
                  disable={view}
                />

                {/* Upload Image */}
                <div>
                  <label className="form-label fw-semibold mb-3">
                    Upload Location Image <span className="text-danger">*</span>
                  </label>
                  <div
                    className="d-flex align-items-center gap-2"
                    style={{ width: "75%", position: "relative" }}
                  >
                    <input
                      ref={fileInputRef}
                      type="file"
                      className="form-control"
                      disabled={view}
                      onChange={(e) => setImageFile(e.target.files[0])}
                    />

                    {imageFile && !view && (
                      <span
                        role="button"
                        onClick={() => {
                          setImageFile(null);
                          if (fileInputRef.current)
                            fileInputRef.current.value = "";
                        }}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "red",
                          fontWeight: "500",
                          cursor: "pointer",
                          background: "#fff",
                          padding: "0 4px",
                          borderRadius: "4px",
                        }}
                      >
                        Change
                      </span>
                    )}
                  </div>
                </div>

                {/* Status */}
                <div className="col-6 row">
                  <label
                    className="form-label title mb-2 g-4"
                    style={{ color: "#4B4853" }}
                    htmlFor=""
                  >
                    Active <span className="star">*</span>
                  </label>
                  <div className="d-flex">
                    <div className="form-check form-check-inline d-flex align-items-center me-3 mt-1">
                      <input
                        className="form-check-input me-3"
                        type="radio"
                        name="status"
                        id="status"
                        value={true}
                        checked={checked}
                        onClick={() => setChecked(true)}
                        {...register("active", { required: true })}
                      />
                      <label htmlFor="option-1" className="text-dark ">
                        Yes
                      </label>
                    </div>
                    <div className="form-check form-check-inline d-flex align-items-center mt-1">
                      <input
                        className="form-check-input me-3"
                        type="radio"
                        name="status"
                        id="status"
                        value={false}
                        checked={!checked}
                        onClick={() => setChecked(false)}
                        {...register("active", { required: true })}
                      />
                      <label htmlFor="option-2" className="text-dark">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="col-md-6 d-flex flex-column gap-4">
                {/* City */}
                <InputTextField
                  register={register}
                  errors={errors}
                  labelName="City"
                  errorText="Please enter the city"
                  name="city"
                  placeholder="Enter City"
                  disable={view}
                />

                {/* Tag + Store Count */}
                <div style={{ width: "75%" }}>
                  <label className="form-label mb-3 fw-semibold">
                    Tag <span className="text-danger">*</span>
                  </label>
                  <div
                    className="rounded shadow-sm d-flex flex-column"
                    style={{ border: "1px solid #e0dede" }}
                  >
                    <div className="d-flex my-3 gap-3">
                      {["Open Now", "Coming Soon"].map((option) => (
                        <div
                          key={option}
                          className="form-check form-check-inline gap-2"
                        >
                          <input
                            type="radio"
                            value={option}
                            disabled={view}
                            {...register("tag", { required: true })}
                          />
                          <label>{option}</label>
                        </div>
                      ))}
                    </div>

                    {watch("tag") === "Open Now" && (
                      <div className="m-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter No of Stores (e.g. 5, 10+)"
                          disabled={view}
                          {...register("storeCount", {
                            required: "Please enter number of stores",
                            pattern: {
                              value: /^[0-9+]+$/,
                              message: "Only numbers and + allowed",
                            },
                          })}
                        />
                        {errors.storeCount && (
                          <p className="text-danger mt-1">
                            {errors.storeCount.message}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Submit */}
              {!view && (
                <div className="m-5 text-center">
                  <button
                    type="submit"
                    className="btn btn-success"
                    style={{ border: "none" }}
                  >
                    Submit
                  </button>
                </div>
              )}
            </div>
          </form>
        </div>
      </MainconternLayout>

      {success && (
        <SucessModal
          page={"/franchise-programme/store-locations"}
          name="new StoreLocation"
          post={edit ? "updated" : "added"}
          onClose={() => navigate("/franchise-programme/store-locations")}
        />
      )}
    </>
  );
};

export default AddStoreLocationForm;
